import React from "react";
import ErrorLabel from "../error_label";
import _ from 'lodash';



const CompanyList = (props) => {


    return (
        <>
            <div class="card mt-3">
                <div class="card-body">
                    <div class="">
                        <span class="fw-bold">Company List</span>
                    </div>
                    <div class="cmpny_container">
                        <div class="row px-3">
                            {props.data != null && props.data.length > 0 ?
                                props.data.map((item, index) => {
                                    return (
                                        <div class="col-12 mt-1 px-0" onClick={() => {
                                            props.onSelect(item.id)
                                        }}>
                                            <div class="cmpny_lsit">
                                                <div class={`py-1 px-2 ${props.selectedItem === item.id ? 'text-primary' : ''}`}>
                                                    <i class="fa fa-building me-2"></i>
                                                    {_.capitalize(item.name)}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyList;